export default "__VITE_ASSET__BulFiLNo__"